import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Patient} from '../../../entities/Patient';
import {AbstractDataTableComponent} from '../../generics/AbstractDataTableComponent';
import {MeasurementStub} from '../../../entities/MeasurementStub';
import {MeasurementService} from '../../../services/measurement.service';
import {Subject, Subscription} from 'rxjs';
import {saveAs} from 'file-saver';
import * as moment from 'moment';

declare var jQuery: any;

@Component({
  selector: 'app-patient-detail-measurements',
  templateUrl: './patient-detail-measurements.component.html',
  styleUrls: ['./patient-detail-measurements.component.scss']
})
export class PatientDetailMeasurementsComponent extends AbstractDataTableComponent implements OnInit, OnDestroy {

  @Input() patient: Patient;
  @Input() reloadMeasurements: Subject<boolean> = new Subject<boolean>();
  measurementStubs: Array<MeasurementStub> = [];
  subs: Array<Subscription> = [];

  constructor(private measurementService: MeasurementService) {
    super('patient-measurements-list');
  }
  

  ngOnInit() {

    // input format is 'DD.MM.YYYY HH:mm' from BackEnd
    // DateTables uses Date.parse(xx) for sorting
    // Date.parse(xx) cant parse this specific format, thus it will fall back to string sorting
    // to correctly sort date-de format, we must parse date string via moment manually
    // see: https://stackoverflow.com/a/55000726
    this.dtOptions = {
      columnDefs: [
        {
          targets: 0,
          type: 'date-time',
          render: function (data, type) {
            return type === 'sort' ? moment(data, 'DD.MM.YYYY HH:mm').format('YYYY/MM/DD HH:mm') : data;
          }
        },
        {
          targets: -1,
          orderable: false
        }
      ],
      pagingType: 'full_numbers',
      language: {
        paginate: {
          first: 'Erste',
          previous: 'Zurück',
          next: 'Weiter',
          last: 'Letzte'
        },
        search: 'Suchen:',
        lengthMenu: 'Zeige _MENU_ Einträge',
        info: 'Zeige _START_ bis _END_ von _TOTAL_ Einträgen',
        infoEmpty: 'Keine Einträge verfügbar',
        infoFiltered: '(gefiltert von _MAX_ Einträgen)',
        zeroRecords: 'Keine passenden Einträge gefunden'
      }
    };

    this.reloadMeasurements.subscribe(() => {
      this.getMeasurements();
    });
    
    this.getMeasurements();

  }


  getMeasurements(){
    const sub = this.measurementService.getList(this.patient.pid)
            .subscribe(list => {
              console.log('stubs', list);
              this.measurementStubs = list;
              this.rerender();
            });
    this.subs.push(sub);
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
    this.subs = [];
  }

  getCsv(measurementId, measurementDate, patientId, mandantId): void {
    this.measurementService
        .getMeasurementDetailsCsv(measurementId)
        .subscribe((data: any) => {
          const blob = new Blob([data], { type: 'application/octet-stream' });
          const fileName = mandantId + '_' + patientId + '_' + measurementDate + '_raw.csv';
          saveAs(blob, fileName);
        });
  }

}
